import * as THREE from "three";
import { CSS2DRenderer, CSS2DObject  } from "three/examples/jsm/renderers/CSS2DRenderer.js";
import { Server } from "../Server/Server";
import { Base64tool,utils } from "../../js/tool/Util"
function SensorHotPoints(hotPointClick,onSenssionMessage){
    this.init(hotPointClick,onSenssionMessage);
}
SensorHotPoints.prototype={
    constructor: SensorHotPoints,
    server:null,
    hasAuthor:false,
    msg_data: [],
    base64tool:new Base64tool(),
    utils:new utils(),
    onHotPoitClick:null,
    onSenssionMessage:null,
    connected:false,
    init:function(hotPointClick,onSenssionMessage){
        this.onSenssionMessage=onSenssionMessage;
        this.onHotPoitClick=hotPointClick;
    },
    setHotPoints:function(document,data,scene){
        scene.backround=new THREE.Color(0,0,0);
        scene.children.forEach((child)=>{
            if(child.name==="外部加载的模型"){
                child.children.forEach((mesh)=>{
                    if (mesh.name.indexOf("_hth")!=-1) {
                        const hotPoint=document.createElement('div');
                             hotPoint.className="hotPoint";
                             hotPoint.style.width="60px";
                             hotPoint.style.height="60px";
                             const img=document.createElement('img');
                             img.className="hotPoint_img";
                             img.id="hotPoint_img";
                             img.src=require("@/assets/hotPoint.gif");
                             img.style.width="60px";
                             img.style.height="60px";
                             img.style.background=new THREE.Color(0,0,0);
                             img.onclick=()=>{
                                this.onSenssionClick();
                             }
                             hotPoint.appendChild(img);
                             const objectCSS=new CSS2DObject(hotPoint);
                            mesh.add(objectCSS)
                    }
                })
            }
        })
    },
    initWebSocket:function() {
        this.initWebSocket()
      },
      destroyedWebSocket: function () {
        this.websocketclose();
      },
    getAuthorCallBack:function(data){
        if(data.msg==="success"){
            this.authorization=data.data.jwt;
            this.hasAuthor=true;
            if(this.hasAuthor){
                // this.server.getSenssionHistory(this.authorization,(data)=>{this.getHistoryCallBack(data)});
                this.server.getSenssionInfo(this.authorization);
            }
        }else{
            this.hasAuthor=false;
        }
        console.log(this.authorization)
    },

    onSenssionClick:function(){
        if(!this.connected){
            this.initWebSocket();
        }
        this.onHotPoitClick();
    },

    initWebSocket: function () {
        this.websock = new WebSocket("ws:47.114.80.9:8084/websocket");
        this.websock.onopen =()=>{this.websocketonopen();};
        this.websock.onerror = this.websocketonerror;
        this.websock.onmessage = (e)=>{this.websocketonmessage(e);}
        this.websock.onclose = this.websocketclose;
      },
      websocketonopen: function () {
        console.log("WebSocket连接成功");
        this.connected=true;
        this.server=new Server();
        this.server.getSenssionAuthor("admin","admin",(data)=>{this.getAuthorCallBack(data)});
      },
      websocketonerror: function (e) {
          this.connected=false;
        console.log("WebSocket连接发生错误");
      },
      websocketonmessage: function (e) {
          console.log(e)
        var da = JSON.parse(e.data);
        console.log(da.data)
        var dm=this.base64tool.doDecode(da.data);
        console.log(dm);
        var reg=new RegExp(" ","g");
        var infos=dm.replace(reg,"").split("\\x");
        console.log(infos);
        console.log(infos[1]+""+infos[2]);
        let temp=this.utils.hex2int(infos[1]+""+infos[2]);
        console.log("温度：",temp);
        console.log(infos[3]+""+infos[4]);
        let hum=this.utils.hex2int(infos[3]+""+infos[4]);
        console.log("湿度：",hum)
        let pow=this.utils.hex2int(infos[5]);
        console.log("电量：",pow)
        let msg={};
        msg["temp"]=temp;
        msg["hum"]=hum;
        this.onSenssionMessage(msg)
      },
      websocketclose: function (e) {
          this.connected=false;
        console.log("connection closed (" + e.code + ")");
      },
      closeWebSocket:function(){
          this.websock.close();
      },
      getHistoryCallBack:function(data){
          console.log("获取历史",data)
      }
}
export{
    SensorHotPoints
}